// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bho_jk","CommentListPlaceholder--Legacy":"ih_b bho_rc bho_wq"};